export default "assets/images/manifest-shape-3c202a4a.svg";